import { render } from "./BookOpenIcon.vue?vue&type=template&id=3a04856e"
import script from "./BookOpenIcon.vue?vue&type=script&lang=ts"
export * from "./BookOpenIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script